import { Auth0ContextInterface } from '@auth0/auth0-react';

const stub = (): never => {
  throw new Error('Auth0 is not initialized');
};

export const auth: Auth0ContextInterface = {
  isAuthenticated: false,
  isLoading: false,
  getAccessTokenSilently: stub,
  getAccessTokenWithPopup: stub,
  getIdTokenClaims: stub,
  loginWithRedirect: stub,
  loginWithPopup: stub,
  logout: stub
};

export const setAuthApi = (authApi: Auth0ContextInterface) => Object.assign(auth, authApi);
